import React from "react";
import { Popconfirm } from "antd";
import { DESTINATION_TYPE } from "../constants";
import { TranslateText } from "@/utils/translation";
const t = (textKey) => <TranslateText textKey={textKey} namespace="pos" />;
const TransferConfirmation = ({
  children,
  source,
  destination,
  transferItems = [],
  onConfirm,
}) => {
  if (!destination) {
    return children;
  }

  const sourceName =
    source.type === DESTINATION_TYPE.TABLE ? (
      <span>
        {t("table")} {source.name}
      </span>
    ) : (
      <span>
        {t("room")} {source.name}
      </span>
    );

  const destinationName =
    destination.type === DESTINATION_TYPE.TABLE ? (
      <span>
        {t("table")} {destination.data.name}
      </span>
    ) : (
      <span>
        {t("room")} {destination.data.roomNum}
      </span>
    );

  return (
    <Popconfirm
      placement="topRight"
      title={t("confirm_transfer")}
      okText={t("transfer")}
      cancelText={t("cancel")}
      onConfirm={onConfirm}
      description={
        <div className="space-y-3 max-w-[320px]">
          <div>
            <strong>{t("from")}:</strong> {sourceName}
          </div>
          <div>
            <strong>{t("to")}:</strong> {destinationName}
          </div>

          <div>
            <strong>{t("items")}</strong>

            <ul className="list-disc ml-5 mt-1">
              {transferItems.map((item) => (
                <li key={item.itemId}>
                  {item.name} × {item.quantity}
                </li>
              ))}
            </ul>
          </div>

          {destination.hasOrder && (
            <div className="text-orange-600 text-xs">
              {t("destination_already_has_running_order")}
              <br />
              {t("items_will_be_appended_to_existing_invoice")}
            </div>
          )}
        </div>
      }
    >
      {children}
    </Popconfirm>
  );
};

export default TransferConfirmation;
